import Vue from 'vue'

export const jwtAuthSetup = (instance) => {
  instance.interceptors.request.use((config) => {
    const token = Vue.store.getters.getToken || localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  })

  instance.interceptors.response.use(
    (response) => {
      if (response.data && response.data.token) {
        Vue.store.commit('STORE_TOKEN', response.data.token)
      }
      return response.data
    },
    (error) => {
      if (error.response.status === 401 && Vue.store.getters.getToken) {
        let originalRequest = error.config
        if (canRepeatRequest(originalRequest)) {
          return refreshTokenAndRepeatRequest(instance, originalRequest)
        } else {
          return Vue.store.dispatch('logout')
        }
      } else if (isBadServerResponse(error)) {
        error.response = normalizeErrorResponse(error.response, 'Wystąpił nieoczekiwany błąd aplikacji...')
      }
      return Promise.reject(error)
    }
  )
}

const normalizeErrorResponse = (response, message) => {
  message = message || response.data.error
  if (message) {
    response.data = {
      errors: { message: [ message ] },
      code: response.status
    }
  }
  return response
}

const canRepeatRequest = (request) => {
  const isRefreshTokenPending = Vue.store.getters.isRefreshTokenPending
  return (!request._retry || isRefreshTokenPending) && (request.url.indexOf('/api/token_refreshes') === -1)
}

const refreshTokenAndRepeatRequest = (instance, request) => {
  request._retry = true
  return Vue.store.dispatch('refreshToken').then(
    (response) => {
      const token = response.token ? response.token : Vue.store.getters.getToken
      request.headers.Authorization = 'Bearer ' + token
      return instance(request)
    },
    () => {
      return instance(request)
    }
  )
}

const isBadServerResponse = (error) => {
  return (typeof error.response.data === 'string') || !error.response.data.errors
}

export default {
  jwtAuthSetup
}



// WEBPACK FOOTER //
// ./src/services/httpSetup.js